import { BasePage } from '@/components/ui/base-page'

export function InstitutionalPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add InstitutionalPage specific content here */}
    </BasePage>
  )
}